import { IcMandatory12 } from '@assets/icons/12x12';
import { Field, Icon } from '@chakra-ui/react';

export default function RequiredIndicator() {
  return (
    <Field.RequiredIndicator height="100%" display="flex" alignItems="center">
      <Icon as={IcMandatory12} boxSize="12px" />
    </Field.RequiredIndicator>
  );
}
